import React from 'react';
import type { UnterweisungFrage } from '../../../services/sifa/types';
import { KNOPF_PRIMAER, KNOPF_SEKUNDAER } from './teilnahmeSeiteStil';

/**
 * Eine Frage je Seite, Mehrfachauswahl per Checkbox. Der Client wertet
 * NICHTS aus — die oeffentliche Fassung traegt keine Richtig-Flags, die
 * Bewertung passiert in sifa_teilnahme_abschliessen.
 */
export const FragenAnsicht: React.FC<{
  frage: UnterweisungFrage;
  nummer: number;
  gesamt: number;
  gewaehlt: string[];
  onUmschalten: (antwortId: string) => void;
  onWeiter: () => void;
  onZurueck: () => void;
}> = ({ frage, nummer, gesamt, gewaehlt, onUmschalten, onWeiter, onZurueck }) => (
  <div className="space-y-5">
    <div className="space-y-1">
      <p className="text-sm font-medium text-slate-500">
        Frage {nummer} von {gesamt}
      </p>
      <h2 className="text-xl font-bold text-slate-900">{frage.frage}</h2>
      <p className="text-sm text-slate-500">Mehrere Antworten können richtig sein.</p>
    </div>

    <fieldset className="space-y-2">
      <legend className="sr-only">{frage.frage}</legend>
      {frage.antworten.map((a) => {
        const id = `antwort-${frage.id}-${a.id}`;
        const aktiv = gewaehlt.includes(a.id);
        return (
          <label
            key={a.id}
            htmlFor={id}
            className={`flex items-start gap-3 p-4 min-h-[56px] rounded-xl border-2 cursor-pointer transition-all ${
              aktiv ? 'border-blue-600 bg-blue-50' : 'border-slate-200 hover:border-slate-300 bg-white'
            }`}
          >
            <input
              id={id}
              type="checkbox"
              checked={aktiv}
              onChange={() => onUmschalten(a.id)}
              className="mt-0.5 w-6 h-6 shrink-0 accent-blue-600"
            />
            <span className="text-base text-slate-800 leading-snug">{a.text}</span>
          </label>
        );
      })}
    </fieldset>

    <div className="flex flex-col-reverse sm:flex-row gap-2 sm:justify-between">
      <button type="button" onClick={onZurueck} className={KNOPF_SEKUNDAER}>
        Zurück
      </button>
      <button type="button" onClick={onWeiter} disabled={gewaehlt.length === 0} className={KNOPF_PRIMAER}>
        Weiter
      </button>
    </div>
  </div>
);
